import * as React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Woopower from "../products/Woopower";
import GravityFormsPro from "../products/GravityFormsPro";
import PowerForm7 from "../products/PowerForm7";
import WPForms from "../products/WPForms";
import WPConnectrPro from "../products/WPConnectrPro";
import ProductsOverview from "../products/Overview";
import Subscription from "../woocommerce/Subscription";
import SubscriptionList from "../woocommerce/SubscriptionList";

const redirectActive = window['redirectTo'] !== undefined;
const redirectDest = window['redirectTo'];

window['redirectTo'] = undefined;

if (redirectActive) {
	console.log(`Redirecting to ${redirectDest}`);
}

export default (
	<Switch>
		<Route path="/subscriptions/:id" exact component={Subscription} />
		<Route path="/subscriptions" exact component={SubscriptionList} />
		<Route path="/products" exact component={ProductsOverview} />
		<Route path="/products/woopower" exact component={Woopower} />
		<Route path="/products/gravity-forms-pro" exact component={GravityFormsPro} />
		<Route path="/products/power-form-7" exact component={PowerForm7} />
		<Route path="/products/wpforms" exact component={WPForms} />
		<Route path="/products/wp-connectr-pro" exact component={WPConnectrPro} />
		<Route path="*">
			<Redirect push to={redirectDest || "/products"} />
		</Route>
	</Switch>
);
